<div
  class="table-container border-1 border-neutral-base-primary-border border-round-lg"
>
  @if (tableData) {
    <table class="w-full">
      <caption class="hidden"></caption>
      <thead>
        <tr class="border-bottom-1 border-neutral-base-primary-border">
          @if (showIndex) {
            <th
              class="py-spacing-xs px-spacing-md text-caption-color font-normal index"
            >
              <span class="content">#</span>
            </th>
          }
          @for (col of tableData.columns; track $index) {
            @if (col.name != "id") {
              <th
                class="py-spacing-xs px-spacing-md text-caption-color font-normal text-left"
              >
                <span
                  class="content"
                  [ngClass]="{ capitalize: !col.displayName }"
                >
                  {{
                    col.displayName
                      ? col.displayName
                      : (col.name | keyDisplayName)
                  }}
                </span>
              </th>
            }
          }
        </tr>
      </thead>

      <tbody>
        @for (item of tableData.data; track $index) {
          <tr>
            @if (showIndex) {
              <td
                class="p-spacing-md bg-white text-secondary-color line-height-3 index"
              >
                <div class="content">
                  <span>{{ $index + 1 }}</span>
                </div>
              </td>
            }
            @for (col of tableData.columns; track $index) {
              @if (col.name != "id") {
                <td
                  class="p-spacing-md bg-white text-secondary-color line-height-3"
                >
                  <div class="content flex flex-column gap-spacing-default">
                    @if (col.type == "array") {
                      @for (el of item[col["name"]]; let i = $index; track i) {
                        @if (col.name != "contacts") {
                          <span>{{ el }}</span>
                        } @else {
                          <span>{{ el.name }}</span>
                          <div
                            class="flex gap-spacing-default flex-column lg:flex-row"
                          >
                            <span
                              class="text-sm form-border-hover-color max-w-max px-spacing-default border-1 form-border-default-border line-height-2 border-round"
                            >
                              {{ el.relation }}
                            </span>
                            <span class="text-light-color text-sm">{{
                              el.number
                            }}</span>
                          </div>
                        }
                      }
                    } @else if (col.type == "icon") {
                      <span>
                        @if (item[col["name"]] == "no-icon") {
                          <span class="text-secondary-color text-sm">None</span>
                        }
                        <img width="48px" [src]="item[col['name']]" alt="" />
                      </span>
                    } @else if (col.type == "customContacts") {
                      @if (item[col["name"]]?.length > 0) {
                        @for (contact of item[col["name"]]; track $index) {
                          <div class="flex flex-column gap-spacing-default">
                            <span class="text-secondary-color">
                              {{ contact.name }}
                            </span>
                            <div class="item flex gap-spacing-xs">
                              <div
                                class="form-border-default-border border-solid body-small-medium text-light-color py-spacing-none px-spacing-3xs border-1 radius-default flex align-items-center"
                              >
                                {{ contact.type }}
                              </div>
                              <span class="text-secondary-color">{{
                                contact.description
                              }}</span>
                            </div>
                          </div>
                        }
                      } @else {
                        <div class="item">
                          <span
                            class="label-medium-regular text-secondary-color"
                          >
                            N/A</span
                          >
                        </div>
                      }
                    } @else if (col.type == "button") {
                      @if (
                        col.name === "Instructions" &&
                        tableName === "Destination" &&
                        !item._hasInstructions
                      ) {
                        <span class="label-medium-regular text-secondary-color">
                          N/A
                        </span>
                      } @else {
                        <span
                          [pTooltip]="tooltipContent"
                          tooltipPosition="left"
                          [autoHide]="false"
                          class="text-link-color text-sm font-medium"
                        >
                          <span class="cursor-pointer">
                            {{
                              col.name === "Instructions" &&
                              tableName === "Destination"
                                ? "View Note"
                                : col["buttonLabel"]
                            }}
                          </span>
                        </span>

                        <ng-template #tooltipContent>
                          <div class="tooltip-head">
                            <span
                              class="title label-medium-regular text-inverse-color"
                              >{{
                                col.name === "Instructions" &&
                                tableName === "Destination"
                                  ? "View Note"
                                  : col["buttonLabel"]
                              }}</span
                            >
                          </div>

                          <div class="tooltip-body">
                            @if (item[col["name"]]?.length > 0) {
                              @for (
                                tooltipItem of item[col["name"]];
                                track $index
                              ) {
                                <div class="item" style="max-width: 300px">
                                  <span
                                    class="label-medium-medium text-inverse-color"
                                    >{{ tooltipItem.type }}</span
                                  >
                                  <span
                                    class="label-medium-regular text-inverse-color"
                                    >{{ tooltipItem.description }}</span
                                  >
                                </div>
                              }
                            } @else {
                              <div class="item">
                                <span
                                  class="label-medium-regular text-inverse-color"
                                  >{{
                                    col.name === "contacts"
                                      ? "No Contacts Available"
                                      : "No Instructions Available"
                                  }}</span
                                >
                              </div>
                            }
                          </div>
                        </ng-template>
                      }
                    } @else if (col.type == "html") {
                      <span [innerHTML]="item[col['name']]"></span>
                    } @else if (col.type == "tag") {
                      @if (item[col["name"]]?.label) {
                        <app-tag
                          [content]="item[col['name']].label"
                          [severityClass]="item[col['name']].severity"
                          styleClass="bold"
                          sizeClass="tag-sm"
                        />
                      } @else {
                        <span>N/A</span>
                      }
                    } @else {
                      <span
                        [pTooltip]="
                          col.name == 'email' ? item[col['name']] : ''
                        "
                        tooltipPosition="bottom"
                        [autoHide]="false"
                        >{{
                          col.name == "email"
                            ? item[col["name"]]?.length > 20
                              ? (item[col["name"]] | slice: 0 : 20) + "..."
                              : item[col["name"]]
                            : item[col["name"]]
                              ? item[col["name"]]
                              : "N/A"
                        }}</span
                      >

                      @if (col.hasTag) {
                        <span
                          class="text-sm align-self-start form-border-hover-color px-spacing-default border-1 form-border-default-border line-height-2 border-round body-small-medium text-light-color"
                        >
                          {{ col.tag }}
                        </span>
                      }
                    }
                  </div>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <!-- add empty state -->
  }
</div>
